import { render, staticRenderFns } from "./case-list.vue?vue&type=template&id=7b413cc2&scoped=true&"
import script from "./case-list.vue?vue&type=script&lang=js&"
export * from "./case-list.vue?vue&type=script&lang=js&"
import style0 from "./case-list.vue?vue&type=style&index=0&id=7b413cc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b413cc2",
  null
  
)

export default component.exports